import { productTypes, type ProductType } from './types'

// scorm and xapi share the create/edit/filter flows and both surface as "SCORM"
// in the UI. third_party is a legacy backend type that still renders as "SCORM"
// on pre-existing products but is not creatable or filterable.
export const scormProductTypes: ProductType[] = [
  productTypes.SCORM,
  productTypes.XAPI,
]

// Types whose display name does not follow their backend identifier.
const DISPLAY_LABEL_KEY: Partial<Record<ProductType, string>> = {
  [productTypes.SCORM]: 'productType.SCORM',
  [productTypes.XAPI]: 'productType.SCORM',
  [productTypes.THIRDPARTY]: 'productType.SCORM',
  [productTypes.FAST]: 'productType.fast_course',
  [productTypes.DIALOGUE]: 'productType.fast_dialogue',
}

export const getProductTypeLabelKey = (type: ProductType): string =>
  DISPLAY_LABEL_KEY[type] ?? `productType.${type}`

/**
 * Expands a comma-separated product type filter so that selecting the "SCORM"
 * type (represented by xapi in filter lists) also queries scorm. scorm and xapi
 * are surfaced as a single "SCORM" type in the UI, but the backend stores them
 * as distinct product types, so the filter must include both.
 *
 * @param filterString Comma-separated product type identifiers, e.g. `"xapi,video"`.
 * @returns The filter string with scorm appended when xapi is present but scorm
 * is not. Returns the input unchanged when it is empty or undefined.
 */
export const expandScormProductTypeFilter = (
  filterString?: string
): string | undefined => {
  if (!filterString) return filterString
  const types = filterString.split(',')
  if (
    types.includes(productTypes.XAPI) &&
    !types.includes(productTypes.SCORM)
  ) {
    types.push(productTypes.SCORM)
  }
  return types.join()
}
